export const consultationMainPage = {
    consultationMainPageAskButtonDesktop: {
        rbmail: {
            type: 'click',
            id: '28646167',
        },
    },
    consultationMainPageAskButtonTouch: {
        rbmail: {
            type: 'click',
            id: '28646323',
        },
    },
    consultationMainPageRubricLinkDesktop: {
        rbmail: {
            type: 'click',
            id: '28646178',
        },
    },
    consultationMainPageRubricLinkTouch: {
        rbmail: {
            type: 'click',
            id: '28646333',
        },
    },
    consultationMainPageConsultantLinkDesktop: {
        rbmail: {
            type: 'click',
            id: '28646176',
        },
    },
    consultationMainPageConsultantLinkTouch: {
        rbmail: {
            type: 'click',
            id: '28646331',
        },
    },
    consultationMainPageConsultantTitleDesktop: {
        rbmail: {
            type: 'click',
            id: '28646169',
        },
    },
    consultationMainPageConsultantTitleTouch: {
        rbmail: {
            type: 'click',
            id: '28646329',
        },
    },
    consultationMainPageDisplayCount: {
        rbmail: {
            type: 'display',
            id: '198211520',
        },
    },
} as const;
